import { Component, NgZone, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: 'app-add-new-topic',
  templateUrl: './add-new-topic.component.html',
  styleUrls: ['./add-new-topic.component.scss']
})
export class AddNewTopicComponent implements OnInit {

	openOptions: Boolean = false;
	error = "";
  subTopicsError = "";
  options = [];
  topicName = "";

  constructor(
    public dialogRef: MatDialogRef<AddNewTopicComponent>,
    private ngZone: NgZone
  ) {
		this.ngZone.run(() => {
      this.options.push("");
    });
  }

  ngOnInit() {
    this.onInit();
  }

  onInit(): void {
  }

  onNoClick(): void {
		this.ngZone.run(() => {
      this.dialogRef.close({ result: false });
    });
  }

  onOkayClick(): void {
    this.error = "";
    this.ngZone.run(() => {
      if (this.topicName.length === 0) {
        this.error = "Topic name is required";
      } else {
        let subtopics = [];
        if(this.checkDuplicateOptions()) {
          this.options.forEach((option) => {
            if (option.length !== 0) {
              subtopics.push(option)
            }
          })
          this.dialogRef.close({ result: true, topic: this.topicName, subtopics: subtopics });
        } else {
          this.subTopicsError = "Subtopics should be different and not empty"
          this.error = "Subtopics should be different and not empty"
        }
      }
    });
  }

  checkDuplicateOptions() {
    return new Set(this.options).size == this.options.length
  }

  checkEmptyOption() {
    for(let option of this.options) {
      if(option == "") {
        return false;
      }
    }
    return true;
  }

  fieldTitleChange(input) {
    this.topicName = input;
    this.error = "";
  }

  addNewSubtopicOption() {
    this.options.push("");
  }

  optionValueChange(index, input) {
    this.options[index] = input;
    if(!this.checkDuplicateOptions()) {
      this.subTopicsError = "Subtopics should be different and not empty"
    } else {
      this.subTopicsError = ""
    }
  }

  trackByFn(index) {
    return index;
  }

  onFocusInputField(event) {
    event.target.style.background = '#dfdfdf';
  }

  onFocusOutInputField(event) {
    event.target.style.background = '';
  }
}
